import React, {
  createContext, useContext, useState,
} from 'react';

type BreadcrumbsType = {
  breadcrumbs: {
    current: string,
    prev: string,
  },
};

export const BreadcrumbsContext = createContext<any>({
  breadcrumbs: null,
});

export const useBreadcrumbs = () => useContext(BreadcrumbsContext);

export const BreadcrumbsProvider: React.FC = ({ children }) => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbsType | null>(null);

  return (
    <BreadcrumbsContext.Provider value={{
      breadcrumbs, setBreadcrumbs,
    }}
    >
      {children}
    </BreadcrumbsContext.Provider>
  );
};
